<template>
  <div class="home mt-2">
    <div v-show="loading" style="margin-top:40vh" class="container">
      <center>
        <a-spin/>
      </center>
    </div>
    <div v-show="!loading">
      <bread-crumbs :from="{name: 'Users', type: 'user',link:'users'}" :to="{name: 'Edit User'}"></bread-crumbs>
      <a-row class="pl-2 pr-3">
        <a-col :span="15">
          <h2 class="text-bold">{{user.first_name}} {{user.last_name}}</h2>
          <h5 style="line-height:20px" class="text-opacity">
            Create New user, assign roles, and update
            <br>User information here.
          </h5>
        </a-col>
      </a-row>

      <a-row class="pl-2 pr-3">
        <a-col :span="24">
          <users-card :user="user" :mode="'edit'" :roles="roles"></users-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import UsersCard from "@/components/Cards/Users";
import BreadCrumbs from "@/components/Headers/BreadCrumbs.vue";
export default {
  data() {
    return {
      hide: false,
      show: true,
      loading: true,
      display: "password",
      form: this.$form.createForm(this, { name: "coordinated" }),
      location: {
        selected_country: "",
        selected_state: ""
      },
      user: {
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        phone: "",
        password: "",
        country_id: "",
        state_id: "",
        city_id: "",
        postal_code: "",
        address: "",
        roles: []
      },
      roles: []
    };
  },
  components: { UsersCard, BreadCrumbs },
  methods: {
    getUser() {
      this.$store
        .dispatch("getUser", this.$route.params.id)
        .then(s => {
          this.loading = false;
          this.user = s.data;
        })
        .catch(d => {
          this.$message.error("The User for that ID couldnt be found");
        });
    },
    fetchRoles() {
      this.$store.dispatch("getRoles").then(s => {
        this.roles = s;
      });
    }
  },
  mounted() {
    this.getUser();
    this.fetchRoles();
  }
};
</script>
